/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["om",[["WD","WB"]],u,[["D","W","K","R","K","J","S"],["Dil","Wix","Kib","Rob","Kam","Jim","San"],["Dilbata","Wiixata","Kibxata","Roobii","Kamisa","Jimaata","Sanbata"],["Dil","Wix","Kib","Rob","Kam","Jim","San"]],u,[["A","G","B","E","C","W","A","H","F","O","S","M"],["Ama","Gur","Bitootessa","Elb","Cam","Wax","Ado","Hag","Ful","Onk","Sadaasa","Mud"],["Amajjii","Guraandhala","Bitootessa","Eebila","Caamsaa","Waxabajjii","Adoolessa","Hagayya","Fulbaana","Onkoloolessa","Sadaasa","Mudde"]],u,[["Dh","B"],["DhKD","BA"],["Dhaloota Kiristoos Dura","Bara Araaraa"]],0,[6,0],["M/d/yy","MMM d, y","MMMM d, y","EEEE, MMMM d, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"ETB","Br","Itoophiyaa Birrii",{"ETB":["Br"],"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
